import customConfirmationEtResponse from "../../../../src/content/ethiopia-response-page/customConfirmation.js";
import { LandingPageResponse } from '@bgea-js/form-templates';
import * as React from 'react';
export default {
  customConfirmationEtResponse,
  LandingPageResponse,
  React
};